import { render, staticRenderFns } from "./PreferredMeals.vue?vue&type=template&id=0b490cbb&scoped=true"
import script from "./PreferredMeals.vue?vue&type=script&lang=js"
export * from "./PreferredMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b490cbb",
  null
  
)

export default component.exports